import { NextPage } from 'next'
import Head from 'next/head'
import { useState } from 'react'
import Confetti from 'react-dom-confetti'
import { useTranslation } from 'react-i18next'
import useSWR from 'swr'
import { useWeb3React } from '@web3-react/core'
import { getAddressShare } from '~/apis'
import Footer from '~/components/Footer'
import Header from '~/components/Header'
import { StyledLonPageHelper } from '../../styled'
import { StyledActivateWrapper } from './styled'
import { ActivateContent } from './Content'

const Activate: NextPage = () => {
  const { t } = useTranslation()

  const [activated, setActivated] = useState(false)

  const { account: address } = useWeb3React()
  const { data, isValidating: loading } = useSWR(
    address ? ['getAddressShare', address] : null,
    () => getAddressShare(address),
  )
  const boundCode = data?.boundCode

  return (
    <StyledLonPageHelper>
      <Head>
        <title>{t('meta_lon_trade_title')}</title>
        <meta name="description" content={t('meta_lon_trade_description')} />
        <meta name="keywords" content={t('meta_lon_keywords')} />
      </Head>
      <Header />
      <StyledActivateWrapper>
        <div className="lon-activate">
          <ActivateContent
            loading={loading}
            boundCode={boundCode}
            activated={activated}
            setActivated={setActivated}
          />
          <div style={{ position: 'absolute', left: '50%' }}>
            <Confetti
              active={activated || !!boundCode}
              config={{
                angle: 90,
                spread: 360,
                startVelocity: 40,
                elementCount: 70,
                dragFriction: 0.12,
                duration: 3000,
                stagger: 3,
                width: '10px',
                height: '10px',
                colors: ['#a864fd', '#29cdff', '#78ff44', '#ff718d', '#fdff6a'],
              }}
            />
          </div>
        </div>
      </StyledActivateWrapper>
      <Footer />
    </StyledLonPageHelper>
  )
}

export default Activate
